<!-- SUBSCRIPTION HOLDER / PAYER -->
<ng-container *apSecure='[Permissions.ACCESS_ALL_SUBSCRIPTIONS]'>
  @if (subscription) {
    <ap-panel>
      <ap-panel-content>
        <div class='form-horizontal form-label-left'>
          @if (subscription) {
            <div class='row subscription-holder-payer-container'>
              <!-- SUBSCRIPTION HOLDER / PAYER INFORMATIONS -->
              <div class='row row-no-margin'>
                <!-- SUBSCRIPTION HOLDER -->
                @if (showHolderInfos()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>
                    <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.TITLE' | translate }}@if (userView) {
                      <span> {{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.TITLE_USER_VIEW' | translate }}</span>
                    }</span>
                    <!-- ACCOUNT ID -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.ACCOUNT_ID' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>
                        <code>{{ subscription.subscriptionHolder?.accountId | noData }}</code>
                        <button (click)='navigateToUser(subscription.subscriptionHolder?.accountId)' type='button' class='btn btn-xs btn-default user-button-dialog'><i class='fa fa-user'></i></button>
                      </div>
                    </div>
                    <!-- IDENTITY STATUS -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.IDENTITY_STATUS' | translate }}</label>
                      @if (subscription.subscriptionHolder.identityStatus) {
                        <div class='col-sm-6 col-md-6 col-xs-6'><status-label [status]='subscription.subscriptionHolder.identityStatus'></status-label></div>
                      }
                      @if (!subscription.subscriptionHolder.identityStatus) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
                      }
                    </div>
                    <!-- CIVILITY -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.CIVILITY' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionHolder.title | noData }}</div>
                    </div>
                    <!-- FIRST NAME -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.FIRST_NAME' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionHolder.firstName | noData }}</div>
                    </div>
                    <!-- LAST NAME -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.LAST_NAME' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionHolder.lastName | noData }}</div>
                    </div>
                    <!-- EMAIL -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.EMAIL' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionHolder.contactDetails?.emailAddress | noData }}</div>
                    </div>
                    <!-- DATE OF BIRTH -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.DATE_OF_BIRTH' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionHolder.birthDate | date: "dd/MM/yyyy" | noData }}</div>
                    </div>
                  </div>
                }
                <!-- SUBSCRIPTION PAYER PAYMENT MEAN AND ADDRESS -->
                @if (showPayerPaymentsInfosInFirstRow()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>
                    <!-- BILLING ADDRESS -->
                    <div class='form-group'>
                      <label class='billing-address col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.BILLING_ADDRESS' | translate }}</label>
                      @if (subscription.subscriptionPayer?.address) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>
                          <status-label [status]='subscription.subscriptionPayer?.address.status' type='HOME'></status-label>
                          <p >
                            {{ subscription.subscriptionPayer?.address.number }} {{ subscription.subscriptionPayer?.address.street }}
                            {{ subscription.subscriptionPayer?.address?.complement ? ' ' + subscription.subscriptionPayer?.address.complement : '' }}, {{ subscription.subscriptionPayer?.address?.postalCode }}
                            {{ subscription.subscriptionPayer?.address?.city }} {{ subscription.subscriptionPayer?.address?.country }}
                          </p>
                        </div>
                      }
                      @if (!subscription.subscriptionPayer?.address) {
                        <div>-</div>
                      }
                    </div>
                    <!-- PAYMENT MEAN -->
                    @if (subscription.subscriptionPayer?.paymentMean) {
                      <div class='accordion' id='accordion' role='tablist' aria-multiselectable='true'>
                        <div class='panel'>
                          <ap-subscription-payment-mean [paymentMean]='subscription.subscriptionPayer?.paymentMean'></ap-subscription-payment-mean>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- SUBSCRIPTION PAYER -->
                @if (!showPayerPaymentsInfosInFirstRow() && showPayerInfos()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>
                    <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.TITLE' | translate }}@if (userView) {
                      <span> {{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.TITLE_USER_VIEW' | translate }}</span>
                    }</span>
                    <!-- ACCOUNT ID -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.ACCOUNT_ID' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>
                        <code>{{ subscription.subscriptionPayer?.accountId | noData }}</code>
                        <button (click)='navigateToUser(subscription.subscriptionPayer?.accountId)' type='button' class='btn btn-xs btn-default user-button-dialog'><i class='fa fa-user'></i></button>
                      </div>
                    </div>
                    <!-- IDENTITY STATUS -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.IDENTITY_STATUS' | translate }}</label>
                      @if (subscription.subscriptionPayer?.identityStatus) {
                        <div class='col-sm-6 col-md-6 col-xs-6'><status-label [status]='subscription.subscriptionPayer?.identityStatus'></status-label></div>
                      }
                      @if (!subscription.subscriptionPayer?.identityStatus) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
                      }
                    </div>
                    <!-- CIVILITY -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.CIVILITY' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionPayer?.title | noData }}</div>
                    </div>
                    <!-- FIRST NAME -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.FIRST_NAME' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionPayer?.firstName | noData }}</div>
                    </div>
                    <!-- LAST NAME -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.LAST_NAME' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionPayer?.lastName | noData }}</div>
                    </div>
                    <!-- EMAIL -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.EMAIL' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionPayer?.contactDetails?.emailAddress | noData }}</div>
                    </div>
                    <!-- DATE OF BIRTH -->
                    <div class='form-group'>
                      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.DATE_OF_BIRTH' | translate }}</label>
                      <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.subscriptionPayer?.birthDate | date: "dd/MM/yyyy" | noData }}</div>
                    </div>
                  </div>
                }
              </div>
              <!-- SUBSCRIPTION HOLDER / PAYER PAYMENT MEAN AND ADDRESS -->
              <div class='row row-no-margin'>
                <!-- SUBSCRIPTION HOLDER PAYMENT MEAN AND ADDRESS -->
                @if (showHolderPaymentsInfos()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>
                    <!-- BILLING ADDRESS -->
                    <div class='form-group'>
                      <label class='billing-address col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.HOLDER.BILLING_ADDRESS' | translate }}</label>
                      @if (subscription.subscriptionHolder.address) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>
                          <status-label [status]='subscription.subscriptionHolder.address.status' type='HOME'></status-label>
                          <p>
                            {{ subscription.subscriptionHolder.address.number }} {{ subscription.subscriptionHolder.address.street }}
                            {{ subscription.subscriptionHolder.address?.complement ? ' ' + subscription.subscriptionHolder.address.complement : '' }}, {{ subscription.subscriptionHolder.address?.postalCode }}
                            {{ subscription.subscriptionHolder.address?.city }} {{ subscription.subscriptionHolder.address?.country }}
                          </p>
                        </div>
                      }
                      @if (!subscription.subscriptionHolder.address) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
                      }
                    </div>
                    <!-- PAYMENT MEAN -->
                    @if (subscription.subscriptionHolder.paymentMean) {
                      <div class='accordion' id='accordion' role='tablist' aria-multiselectable='true'>
                        <div class='panel'>
                          <ap-subscription-payment-mean [paymentMean]='subscription.subscriptionHolder?.paymentMean'></ap-subscription-payment-mean>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- SUBSCRIPTION PAYER PAYMENT MEAN AND ADDRESS -->
                @if (!userView && !showPayerPaymentsInfosInFirstRow() && !showHolderPaymentsInfos() && showPayerPaymentsInfos()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'></div>
                }
                @if (!showPayerPaymentsInfosInFirstRow() && showPayerPaymentsInfos()) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>
                    <!-- BILLING ADDRESS -->
                    <div class='form-group'>
                      <label class='billing-address col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYER.BILLING_ADDRESS' | translate }}</label>
                      @if (subscription.subscriptionPayer?.address) {
                        <div class='col-sm-6 col-md-6 col-xs-6'>
                          <status-label [status]='subscription.subscriptionPayer?.address.status' type='HOME'></status-label>
                          <p >
                            {{ subscription.subscriptionPayer?.address.number }} {{ subscription.subscriptionPayer?.address.street }}
                            {{ subscription.subscriptionPayer?.address?.complement ? ' ' + subscription.subscriptionPayer?.address.complement : '' }}, {{ subscription.subscriptionPayer?.address?.postalCode }}
                            {{ subscription.subscriptionPayer?.address?.city }} {{ subscription.subscriptionPayer?.address?.country }}
                          </p>
                        </div>
                      }
                      @if (!subscription.subscriptionPayer?.address) {
                        <div>-</div>
                      }
                    </div>
                    <!-- PAYMENT MEAN -->
                    @if (subscription.subscriptionPayer?.paymentMean) {
                      <div class='accordion' id='accordion' role='tablist' aria-multiselectable='true'>
                        <div class='panel'>
                          <ap-subscription-payment-mean [paymentMean]='subscription.subscriptionPayer?.paymentMean'></ap-subscription-payment-mean>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </ap-panel-content>
    </ap-panel>
  }
</ng-container>
